export enum TopMenuId {
    DIAGRAM_MENU = "DIAGRAM_MENU",
    ALIGN_MENU = "ALIGN_MENU",
    VIEW_MENU = "VIEW_MENU",
    TOOLS_MENU = "TOOLS_MENU",
}